'use strict';

var STORAGE_KEY = 'sts_wishlist';
var URL_PARAM   = 'items';

/* ── Storage ─────────────────────────────────────────── */
var Store = {
  get: function() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch(e) { return []; }
  },
  save: function(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  },
  has: function(handle) { return this.get().indexOf(handle) !== -1; },
  toggle: function(handle) {
    var list = this.get();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    this.save(list);
    return i === -1; // true = added
  },
  addAll: function(handles) {
    var list = this.get();
    handles.forEach(function(h) { if (list.indexOf(h) === -1) list.push(h); });
    this.save(list);
  }
};

/* ── URL helpers ─────────────────────────────────────── */
function shareUrl() {
  var list = Store.get();
  if (!list.length) return window.location.origin + '/pages/wishlist';
  var u = new URL('/pages/wishlist', window.location.origin);
  u.searchParams.set(URL_PARAM, list.join(','));
  return u.toString();
}

function handlesFromUrl() {
  var p = new URLSearchParams(window.location.search).get(URL_PARAM);
  return p ? p.split(',').filter(Boolean) : null;
}

/* ── Button state ────────────────────────────────────── */
function applyState(btn, active) {
  btn.classList.toggle('wishlist-btn--active', active);
  btn.setAttribute('aria-pressed', active);
  btn.setAttribute('aria-label', active
    ? (btn.dataset.removeLabel || 'Remove from wishlist')
    : (btn.dataset.addLabel   || 'Add to wishlist'));
}

function syncAll(handle) {
  document.querySelectorAll('[data-wishlist-btn][data-handle]').forEach(function(btn) {
    if (btn.dataset.handle === handle) applyState(btn, Store.has(handle));
  });
}

function attachBtn(btn) {
  if (btn._wlAttached) return;
  btn._wlAttached = true;
  applyState(btn, Store.has(btn.dataset.handle));
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    Store.toggle(btn.dataset.handle);
    syncAll(btn.dataset.handle);
  });
}

function initAllBtns() {
  document.querySelectorAll('[data-wishlist-btn]').forEach(attachBtn);
}

/* ── Wishlist page ───────────────────────────────────── */
function initPage() {
  var page = document.getElementById('wishlist-page');
  if (!page) return;

  var urlHandles = handlesFromUrl();
  var isShared   = urlHandles !== null;
  var handles    = isShared ? urlHandles : Store.get();

  // Show/hide shared vs own UI
  page.querySelectorAll('[data-wishlist-shared]').forEach(function(el) { el.hidden = !isShared; });
  page.querySelectorAll('[data-wishlist-own]').forEach(function(el)    { el.hidden = isShared;  });

  // Save-all button (shared view)
  var saveAllBtn = page.querySelector('[data-wishlist-save-all]');
  if (saveAllBtn) {
    saveAllBtn.addEventListener('click', function() {
      Store.addAll(handles);
      this.textContent = this.dataset.savedLabel || 'Saved!';
      this.disabled = true;
    });
  }

  // Share button (own view)
  var shareBtn    = page.querySelector('[data-wishlist-share]');
  var shareNotify = page.querySelector('[data-wishlist-share-confirm]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      var url = shareUrl();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).catch(function() { prompt('Copy this link:', url); });
      } else {
        prompt('Copy this link:', url);
      }
      if (shareNotify) {
        shareNotify.hidden = false;
        setTimeout(function() { shareNotify.hidden = true; }, 2500);
      }
    });
  }

  var countEl = page.querySelector('[data-wishlist-count]');
  var grid    = page.querySelector('[data-wishlist-grid]');
  var empty   = page.querySelector('[data-wishlist-empty]');

  if (countEl) countEl.textContent = handles.length;

  if (!handles.length) {
    if (grid)  grid.hidden  = true;
    if (empty) empty.hidden = false;
    return;
  }

  var moneyFormat = page.dataset.moneyFormat || '${{amount}}';

  Promise.all(handles.map(fetchProduct)).then(function(results) {
    var products = results.filter(Boolean);
    if (!products.length) {
      if (grid)  grid.hidden  = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (grid) {
      grid.innerHTML = products.map(function(p) {
        return renderCard(p, isShared, moneyFormat);
      }).join('');
      grid.querySelectorAll('[data-wishlist-btn]').forEach(attachBtn);

      // Live remove on un-wishlist (own view only)
      if (!isShared) {
        document.addEventListener('wishlist:updated', function() {
          grid.querySelectorAll('[data-wishlist-card]').forEach(function(card) {
            if (!Store.has(card.dataset.wishlistCard)) {
              card.style.transition = 'opacity 0.3s';
              card.style.opacity    = '0';
              setTimeout(function() { card.remove(); }, 320);
            }
          });
          if (countEl) countEl.textContent = Store.get().length;
          setTimeout(function() {
            if (grid && !grid.querySelector('[data-wishlist-card]') && empty) {
              grid.hidden  = true;
              empty.hidden = false;
            }
          }, 350);
        });
      }
    }
  });
}

function fetchProduct(handle) {
  return fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function(res) { return res.ok ? res.json() : null; })
    .catch(function() { return null; });
}

function formatMoney(cents, format) {
  var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
  return format
    .replace('{{amount}}', amount)
    .replace('{{amount_no_decimals}}', Math.floor(cents / 100))
    .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
    .replace('{{amount_no_decimals_with_comma_separator}}', Math.floor(cents / 100));
}

function resizeImg(src, width) {
  if (!src) return '';
  return src.replace(/(\.[^.?]+)(\?.*)?$/, function(_, ext, q) {
    return '_' + width + 'x' + ext + (q || '');
  });
}

function esc(str) {
  return String(str)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

var HEART_OUTLINE = '<svg class="wishlist-btn__icon wishlist-btn__icon--outline" width="20" height="19" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12.4336 24.7955C4.37365 18.4211 0 13.912 0 8.36463C0 3.59592 2.98985 0 6.96443 0C9.99173 0 11.9787 1.76904 13 3.00927C14.0214 1.76904 16.0086 0 19.0356 0C23.0099 0 26 3.59592 26 8.36463C26 13.9216 21.6264 18.4309 13.5664 24.8053C13.2321 25.0649 12.7678 25.0649 12.4428 24.8053L12.4336 24.7955ZM6.96443 1.92287C4.04872 1.92287 1.85714 4.6918 1.85714 8.36463C1.85714 12.9986 5.76635 17.0655 13 22.8246C20.2336 17.056 24.1429 12.9986 24.1429 8.36463C24.1429 4.6918 21.9514 1.92287 19.0356 1.92287C15.5533 1.92287 13.8264 5.08591 13.8171 5.11483C13.4921 5.73015 12.5171 5.73015 12.1921 5.11483C12.1178 4.98023 10.4185 1.91333 6.9642 1.91333L6.96443 1.92287Z" fill="currentColor"/></svg>';
var HEART_FILLED  = '<svg class="wishlist-btn__icon wishlist-btn__icon--filled" width="20" height="19" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12.4336 24.7955C4.37365 18.4211 0 13.912 0 8.36463C0 3.59592 2.98985 0 6.96443 0C9.99173 0 11.9787 1.76904 13 3.00927C14.0214 1.76904 16.0086 0 19.0356 0C23.0099 0 26 3.59592 26 8.36463C26 13.9216 21.6264 18.4309 13.5664 24.8053C13.2321 25.0649 12.7678 25.0649 12.4428 24.8053L12.4336 24.7955Z" fill="currentColor"/></svg>';

function renderCard(p, isShared, moneyFormat) {
  var v = p.variants[0];
  var price        = formatMoney(v.price, moneyFormat);
  var comparePrice = (v.compare_at_price && v.compare_at_price > v.price)
    ? formatMoney(v.compare_at_price, moneyFormat) : null;
  var imgSrc  = p.featured_image ? resizeImg(p.featured_image, 800) : '';
  var imgHtml = imgSrc
    ? '<img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy">'
    : '<div class="placeholder-image" style="height:100%;background:#f0ebe7;"></div>';

  // First available variant for one-click ATC
  var atcVariant = null;
  for (var i = 0; i < p.variants.length; i++) {
    if (p.variants[i].available) { atcVariant = p.variants[i]; break; }
  }
  if (!atcVariant) atcVariant = p.variants[0];
  var atcBtn = atcVariant && atcVariant.available
    ? '<button class="product-one-click-atc btn btn--secondary" data-one-click-atc="' + atcVariant.id + '" type="button">+ Add to cart</button>'
    : '<button class="product-one-click-atc btn btn--secondary" disabled type="button">Sold out</button>';

  var heartBtn = isShared ? '' : (
    '<button class="wishlist-btn wishlist-btn--card wishlist-btn--active"' +
    ' data-wishlist-btn data-handle="' + esc(p.handle) + '"' +
    ' data-add-label="Add to wishlist" data-remove-label="Remove from wishlist"' +
    ' type="button" aria-pressed="true" aria-label="Remove from wishlist">' +
    HEART_OUTLINE + HEART_FILLED +
    '</button>'
  );

  return (
    '<div class="product-block" data-wishlist-card="' + esc(p.handle) + '">' +
      '<div class="block-inner"><div class="block-inner-inner">' +
        '<div class="image-cont">' +
          '<a class="product-link" href="/products/' + esc(p.handle) + '">' + imgHtml + '</a>' +
          heartBtn +
        '</div>' +
        '<div class="product-block__detail align-ltr-left">' +
          '<div class="inner"><div class="innerer">' +
            '<a class="product-link" href="/products/' + esc(p.handle) + '">' +
              (p.vendor ? '<div class="vendor">' + esc(p.vendor) + '</div>' : '') +
              '<div class="product-block__title">' + esc(p.title) + '</div>' +
              '<div class="product-price product-price--block">' +
                (comparePrice ? '<span class="price__was">' + esc(comparePrice) + '</span>' : '') +
                '<span class="price__current">' + esc(price) + '</span>' +
              '</div>' +
            '</a>' +
          '</div></div>' +
        '</div>' +
        atcBtn +
      '</div></div>' +
    '</div>'
  );
}

/* ── Boot ────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  initAllBtns();
  initPage();
});
document.addEventListener('shopify:section:load', initAllBtns);
